import React, { useCallback } from 'react'
import { useGridHelper } from '@@partner:helpers/crud/grid'
import { generatePath } from 'react-router'
import { useFetchAllBannerTypes } from '@@partner:graphql/query/banners/allBannerTypes.gql'

import BannerTypesTable from './grid/BannerTypesTable'
import Pagination from 'rsuite/esm/Pagination/Pagination'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'

import { ROUTE_MARKETING_BANNER_TYPE_EDIT } from '@@partner:config/routes'

export interface BannerGridProps {
  brandSlug: string
}

export default function BannersGrid ({ brandSlug }: BannerGridProps) {
  const { page, tableSort, handlePageSelect, handleSortColumn } =
    useGridHelper()

  const { data, loading, error } = useFetchAllBannerTypes({
    pager: { page },
    sort: {
      fieldName: tableSort.fieldName,
      direction: tableSort.direction
    }
  })

  const generateEditUrl = useCallback(
    (bannerTypeId) => {
      return generatePath(ROUTE_MARKETING_BANNER_TYPE_EDIT, {
        brandSlug,
        bannerTypeId
      })
    },
    [ brandSlug ]
  )

  if (error) {
    return (
      <GraphQLCommonErrorDisplay
        title="Ошибка загрузки промокодов"
        error={error}
      />
    )
  }

  return (
    <div>
      <BannerTypesTable
        items={data?.allBannerTypes?.edges ?? []}
        tableSort={tableSort}
        loading={loading}
        onSortColumn={handleSortColumn}
        generateEditUrl={generateEditUrl}
      />

      <Pagination
        last
        first
        next
        prev
        ellipsis
        activePage={page}
        pages={data?.allBannerTypes?.pageInfo?.lastPage}
        maxButtons={10}
        onSelect={handlePageSelect}
      />
    </div>
  )
}
